// ── number → words (Indian system) ──────────────────────────────────────────
const ones = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine",
  "Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen",
  "Eighteen","Nineteen"];
const tens = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];

function numToWords(n) {
  n = Math.round(n);
  if (n === 0) return "Zero";
  if (n < 20) return ones[n];
  if (n < 100) return tens[Math.floor(n/10)] + (n%10 ? " " + ones[n%10] : "");
  if (n < 1000) return ones[Math.floor(n/100)] + " Hundred" + (n%100 ? " " + numToWords(n%100) : "");
  if (n < 100000) return numToWords(Math.floor(n/1000)) + " Thousand" + (n%1000 ? " " + numToWords(n%1000) : "");
  if (n < 10000000) return numToWords(Math.floor(n/100000)) + " Lac" + (n%100000 ? " " + numToWords(n%100000) : "");
  return numToWords(Math.floor(n/10000000)) + " Crore" + (n%10000000 ? " " + numToWords(n%10000000) : "");
}

const toWords = (amount) => {
  const [intPart, decPart] = Number(amount).toFixed(2).split(".");
  let words = "Rupees " + numToWords(parseInt(intPart));
  if (decPart && parseInt(decPart) > 0) words += " and " + numToWords(parseInt(decPart)) + " Paise";
  return words + " Only";
};

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// ── shared style shorthands ───────────────────────────────────────────────
const cp  = "padding:10px 11px";
const cps = "padding:5px 11px";   // slim — bike details table
const cph = "padding:8px 11px";
const f12 = "font-size:12px";
const f13 = "font-size:13px";
const f14 = "font-size:14px";

// ── HTML builder (single source of truth for single + bulk printing) ──────
export const buildInvoiceHTML = (data, forPrint = false) => {
  if (!data) return "";

  const financeCompany =
    (data.payment?.saleType === "FINANCE" || data.payment?.saleType === "EX+FIN") &&
    data.payment?.finance?.company
      ? data.payment.finance.company.toUpperCase()
      : "\u2014";

  const v = (val) => (val && val !== "-" ? val : "");

  const addressLine = [
    v(data.customer.village)       ? "VILL-"  + data.customer.village.toUpperCase()       : "",
    v(data.customer.postOffice)    ? "P.O-"   + data.customer.postOffice.toUpperCase()    : "",
    v(data.customer.policeStation) ? "P.S-"   + data.customer.policeStation.toUpperCase() : "",
    v(data.customer.pinCode)       ?            data.customer.pinCode                     : "",
  ].filter(Boolean).join(", ");

  const supplyLine = [
    v(data.customer.village)       ? "VILL+"  + data.customer.village.toUpperCase()       : "",
    v(data.customer.postOffice)    ? "PO-"    + data.customer.postOffice.toUpperCase()    : "",
    v(data.customer.policeStation) ? "PS-"    + data.customer.policeStation.toUpperCase() : "",
    v(data.customer.pinCode)       ?            data.customer.pinCode                     : "",
  ].filter(Boolean).join(", ");

  const invoiceDate = new Date(data.invoice.date)
    .toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" })
    .replace(/\//g, "-");

  return `
<div style="
  width:${forPrint ? "187mm" : "100%"};
  max-width:${forPrint ? "187mm" : "100%"};
  font-family:Arial,sans-serif;
  font-size:13px;
  color:#000;
  border:2px solid #000;
  padding:${forPrint ? "8px 10px" : "10px 12px"};
  box-sizing:border-box;
  overflow:hidden;
  ${forPrint ? "margin:0 auto;page-break-inside:avoid;break-inside:avoid;" : ""}
">

  <!-- TAX INVOICE LABEL -->
  <div style="text-align:center;font-size:11px;font-weight:bold;letter-spacing:4px;margin-bottom:5px;">
    TAX INVOICE
  </div>

  <!-- COMPANY HEADER -->
  <div style="display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #000;padding-bottom:9px;margin-bottom:0;">
    <img src="/bajaj.png" style="height:64px;width:auto;object-fit:contain;" />
    <div style="text-align:center;flex:1;padding:0 12px;">
    <div style="display:flex;align-items:center;justify-content:center;gap:6px;">
  <span style="font-size:30px;font-weight:900; font:bold">KAB ENTERPRISE</span>
  <span style="font-size:21px;font-weight:900; font:bold">(CODE : A68738)</span>
</div>
   <div style="${f12};margin-top:3px;">VILL + P.O.- CHAITANYAPUR, HALDIA</div>
      <div style="${f12};">DIST.- PURBA MEDINIPUR, WEST BENGAL, 721645</div>
      <div style="${f12};">CONTACT NO.- 8158887262 &nbsp;|&nbsp; EMAIL : kbenterpricepl@gmail.com</div>
      <div style="${f12};">GSTIN NO : 19AAWFK5915A1Z3 &nbsp;&nbsp;&nbsp; PAN : AAWFK5915A</div>
     </div>
    <img src="/bajaj.png" style="height:64px;width:auto;object-fit:contain;" />
  </div>

  <!-- CUSTOMER / PLACE OF SUPPLY / INVOICE NO -->
  <table style="width:100%;border-collapse:collapse;">
    <tr>

      <!-- Bill To -->
      <td style="width:38%;vertical-align:top;border:1px solid #000;${cp};">
        <div style="${f12};font-weight:bold;margin-bottom:3px;">Bill to :</div>
        <div style="font-size:18px;font-weight:900;text-transform:uppercase;line-height:1.2;margin-bottom:5px;">${data.customer.name}</div>
<div style="${f12};font-weight:bold;">
  ADDRESS: <span style="font-weight:normal;">${addressLine}</span>
</div>           
        ${v(data.customer.fatherName)
          ? `<div style="${f12};margin-top:4px;"><b>S/O:</b> ${data.customer.fatherName.toUpperCase()}</div>`
          : ""}
        <div style="${f12};margin-top:4px;"><b>Mobile:</b> ${(data.customer.mobile || []).join(", ")}</div>
${data.customer.gstin
  ? `<div style="${f12};margin-top:4px;"><b>GSTIN :</b> ${data.customer.gstin}</div>`
  : ""}           </td>

      <!-- Place of Supply -->
      <td style="width:29%;vertical-align:top;border:1px solid #000;border-left:none;${cp};">
        <div style="${f12};font-weight:bold;margin-bottom:5px;">Place of Supply :</div>
        <div style="${f12};line-height:1.65;">${supplyLine}</div>
      </td>

      <!-- Invoice No + Date -->
      <td style="width:33%;vertical-align:top;border:1px solid #000;border-left:none;${cp};text-align:center;">
        <div style="${f12};font-weight:bold;margin-bottom:5px;">INVOICE NO</div>
        <div style="font-size:17px;font-weight:900;margin-bottom:10px;">${data.invoice.invoiceNo}</div>
        <div style="${f12};font-weight:bold;margin-bottom:5px;">Dated</div>
        <div style="font-size:16px;font-weight:bold;">${invoiceDate}</div>
      </td>

    </tr>
  </table>

  <!-- DESCRIPTION HEADER -->
  <div style="
    text-align:center;font-weight:bold;font-size:13px;
    border:1px solid #000;border-top:none;
    ${cph};background:#e0e0e0;letter-spacing:4px;
  ">DESCRIPTION</div>

  <!-- BIKE DETAILS -->
  <table style="width:100%;border-collapse:collapse;">
    <tr>
      <td style="border:1px solid #000;border-top:none;${cps};width:18%;font-weight:900;${f14};">MODEL</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};width:32%;${f14};">${data.bike.model}</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};width:12%;font-weight:900;${f14};">COLOUR</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};width:38%;${f14};text-transform:uppercase;">${data.bike.color}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;border-top:none;${cps};font-weight:900;${f14};">CHASSIS NO</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f14};">${data.bike.chasis}</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};font-weight:900;${f14};">FINANCE BY</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f14};font-weight:700;">${financeCompany}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;border-top:none;${cps};font-weight:900;${f14};">ENGINE NO</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f14};">${data.bike.engine}</td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};"></td>
      <td style="border:1px solid #000;border-top:none;border-left:none;${cps};"></td>
    </tr>
  </table>

  <!-- PRICING TABLE -->
  <table style="width:100%;border-collapse:collapse;">
    <thead>
      <tr style="background:#e0e0e0;">
        <th style="border:1px solid #000;border-top:none;${cph};text-align:center;${f12};width:20%;">MODEL</th>
        <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:center;${f12};width:10%;">SKU</th>
        <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:center;${f12};width:12%;">HSN CODE</th>
        <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:center;${f12};width:8%;">QTY</th>
        <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:left;${f12};width:28%;"></th>
        <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:right;${f12};width:22%;">AMOUNT</th>
      </tr>
    </thead>
    <tbody>

      <!-- BASE PRICE -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};${f13};">${data.bike.model}</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:center;">${data.bike.skuCode}</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:center;">87112029</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:center;">1</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};font-weight:bold;">BASE PRICE</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:right;">&#8377; ${fmt(data.pricing.basePrice)}</td>
      </tr>

      <!-- DISCOUNT -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};">DISCOUNT</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:right;">
          ${data.pricing.discount > 0 ? "&#8377; " + fmt(data.pricing.discount) : ""}
        </td>
      </tr>

      <!-- TAXABLE AMOUNT -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};">TAXABLE AMOUNT</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:right;">&#8377; ${fmt(data.pricing.taxableAmount)}</td>
      </tr>

      <!-- CGST -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};">Add CGST @${data.pricing.cgstRate}%</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:right;">&#8377; ${fmt(data.pricing.cgst)}</td>
      </tr>

      <!-- SGST -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};">Add SGST @${data.pricing.sgstRate}%</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:right;">&#8377; ${fmt(data.pricing.sgst)}</td>
      </tr>

      <!-- TOTAL AMOUNT -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f14};font-weight:bold;">TOTAL AMOUNT</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f14};font-weight:bold;text-align:right;">&#8377; ${fmt(data.pricing.totalAmount)}</td>
      </tr>

      <!-- ROUND OFF -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};">ROUND OFF</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};text-align:right;">&#8377; ${fmt(data.pricing.roundOff)}</td>
      </tr>

      <!-- EX SHOWROOM -->
      <tr>
        <td style="border:1px solid #000;border-top:none;${cp};" colspan="3"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};"></td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};font-size:15px;font-weight:bold;">EX SHOWROOM</td>
        <td style="border:1px solid #000;border-top:none;border-left:none;${cp};font-size:15px;font-weight:bold;text-align:right;">&#8377; ${fmt(data.pricing.exShowroomPrice)}</td>
      </tr>

    </tbody>
  </table>

  <!-- AMOUNT IN WORDS -->
  <div style="border:1px solid #000;border-top:none;${cp};">
    <div style="${f13};font-weight:bold;margin-bottom:4px;">Amount (in words)</div>
    <div style="${f13};font-style:italic;">${toWords(data.pricing.totalAmount)}</div>
  </div>

  <!-- BANK + SIGNATURE -->
  <div style="display:flex;margin-top:7px;">

    <!-- Bank -->
    <div style="flex:1;border:1px solid #000;${cp};${f12};line-height:1.9;">
      <div style="font-weight:bold;margin-bottom:4px;">Bank / Payment Details</div>
      <div>BANK- PUNJAB NATIONAL BANK, CHAITANYAPUR BRANCH</div>
      <div>A/C Name- KAB ENTERPRISE</div>
      <div>A/C NO- 1928056000068</div>
      <div>IFSC CODE- PUNB0192820 , MICR CODE - 721027601</div>
     </div>

    <!-- Seal + Signatures -->
    <div style="flex:1;border:1px solid #000;border-left:none;${cp};display:flex;flex-direction:column;justify-content:space-between;min-height:115px;">
      <div style="text-align:right;">
        <div style="
          width:78px;height:78px;
           margin-left:auto;
          display:flex;align-items:center;justify-content:center;
          color:#aaa;font-size:10px;font-weight:bold;letter-spacing:1px;
        "> </div>
      </div>
      <div style="display:flex;justify-content:space-between;margin-top:14px;align-items:flex-end;">
        <div style="text-align:center;">
          <div style="border-top:1.5px solid #000;width:125px;margin-bottom:4px;"></div>
          <div style="font-size:11px;font-weight:bold;">Customer Sign</div>
        </div>
        <div style="text-align:center;">
          <div style="border-top:1.5px solid #000;width:135px;margin-bottom:4px;"></div>
          <div style="font-size:11px;font-weight:bold;">Authorised Signatory</div>
        </div>
      </div>
    </div>

  </div>

</div>
`;
};